import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const MedicalTechnologyId = entityId('medicalTechnology')

export type MedicalTechnologyIdType = typeof MedicalTechnologyId.Type

export const MedicalTechnologySchema = AppEntity.extend({
  id: MedicalTechnologyId.schema,
  name: z.string().min(1).max(255),
  name2: z.string().nullish(),
  comment: z.string().nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullish(),
})

export type MedicalTechnology = z.infer<typeof MedicalTechnologySchema>
